export default __webpack_public_path__ + "static/product_sans_bold-webfont-4e20871255be181af9f8e3d70ab663ba.woff";